// extracted by mini-css-extract-plugin
export default {"fileViewer":"styles_fileViewer__dy8Wt","loaderContainer":"styles_loaderContainer__BzJvd"};